import styled from "@emotion/styled";
import theme from "@theme";

const BodyHeader = styled.div`
  padding: 16px 24px;
  background: linear-gradient(135deg, #e36e00 0%, #ffae00 100%);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: fixed;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const BodyContainer = styled.div`
  margin-top: 60px;
  background: linear-gradient(135deg, #fef4e9 0%, #ffe4b3 100%);
  min-height: calc(100vh - 60px);
  width: 100%;
`;

const HeadingTag = styled.p`
  float: left;
  margin: 8px;
  padding: 0px 24px 0px 0px;
  font-weight: 600;
  font-size: 16px;
  color: #2d3748;
`;

const FilterContainer = styled.div`
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 0rem;
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  @media (min-width: 640px) {
    padding: 1.25rem 1.5rem;
    gap: 1rem;
  }

  @media (min-width: 768px) {
    padding: 1.5rem 2rem;
    gap: 1.25rem;
  }

  @media (min-width: 1024px) {
    padding: 1.5rem 2.5rem;
    gap: 1.5rem;
  }

  @media (max-width: 639px) {
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
`;

const FilterOption = styled.p`
  padding: 8px 0px;
  color: #4a5568;
  font-weight: 500;
`;

const Container = styled.div`
  max-width: 100%;
  margin: 0 auto;
  width: 100%;
  padding: 1rem;

  @media (min-width: 640px) {
    padding: 1.5rem;
    max-width: 95vw;
  }

  @media (min-width: 768px) {
    padding: 2rem;
    max-width: 90vw;
  }

  @media (min-width: 1024px) {
    padding: 2.5rem;
    max-width: 85vw;
  }

  @media (min-width: 1280px) {
    padding: 3rem;
    max-width: 1400px;
  }
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  margin-bottom: 1.5rem;

  /* Ensure all grid items have the same width */
  & > * {
    width: 100%;
    min-width: 0;
  }
`;

const DetailsCard = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 1rem;
  padding: 1.25rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  height: fit-content;
  width: 100%;
  min-width: 0;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  }

  &:focus-within {
    outline: 2px solid rgba(227, 110, 0, 0.3);
    outline-offset: 2px;
  }

  @media (min-width: 640px) {
    padding: 1.5rem;
    border-radius: 1.25rem;
  }

  @media (min-width: 768px) {
    padding: 2rem;
  }

  @media (min-width: 1024px) {
    padding: 2.5rem;
  }

  @media (min-width: 1280px) {
    padding: 3rem;
  }
`;

const DetailsContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  margin-top: 1rem;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }

  @media (min-width: 1024px) {
    gap: 2.5rem;
  }

  @media (min-width: 1280px) {
    gap: 3rem;
  }
`;

const DetailsSection = styled.div`
  width: 100%;
  min-width: 0;
`;

const ImageSection = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ImageCard = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 1rem;
  padding: 1.25rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  height: fit-content;
  width: 100%;
  min-width: 0;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  }

  &:focus-within {
    outline: 2px solid rgba(227, 110, 0, 0.3);
    outline-offset: 2px;
  }

  @media (min-width: 640px) {
    padding: 1.5rem;
    border-radius: 1.25rem;
  }

  @media (min-width: 768px) {
    padding: 2rem;
  }

  @media (min-width: 1024px) {
    padding: 2.5rem;
  }

  @media (min-width: 1280px) {
    padding: 3rem;
  }
`;

const ImageContainer = styled.div`
  width: 50px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: #f8fafc;
  box-shadow: 0 4px 15px rgba(227, 110, 0, 0.15);
  border: 1px solid rgba(227, 110, 0, 0.1);
  overflow: hidden;
  position: relative;

  @media (max-width: 768px) {
    width: 45px;
    height: 35px;
  }
`;

const Image = styled.div`
  width: 100%;
  height: auto;
  border-radius: 0.75rem;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(227, 110, 0, 0.1);
  box-shadow: 0 4px 15px rgba(227, 110, 0, 0.15);
  transition: all 0.3s ease;
  position: relative;
  cursor: pointer;
  padding: 0;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
    transition: transform 0.3s ease;
    display: block;
  }

  &:hover {
    box-shadow: 0 8px 25px rgba(227, 110, 0, 0.2);
    transform: scale(1.02);

    img {
      transform: scale(1.1);
    }
  }

  @media (min-width: 640px) {
    border-radius: 1rem;
  }
`;

const ProjectDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
`;

const PropertyName = styled.span`
  font-weight: 700;
  font-size: 1.5rem;
  background: linear-gradient(135deg, #e36e00 0%, #ffae00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1rem;
  letter-spacing: -0.5px;
  display: inline-block;
  vertical-align: middle;
  line-height: 1.2;

  @media (min-width: 640px) {
    font-size: 1.75rem;
  }

  @media (min-width: 1024px) {
    font-size: 2rem;
  }

  @media (min-width: 1280px) {
    font-size: 2.25rem;
  }

  @media (max-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

const Status = styled.div`
  color: ${(props) =>
    props.currentProject.status === 1 ? "#10b981" : "#ef4444"};
  font-weight: 600;
  font-size: 14px;
  margin: 8px 0px;
  padding: 6px 12px;
  background: ${(props) =>
    props.currentProject.status === 1
      ? "rgba(16, 185, 129, 0.1)"
      : "rgba(239, 68, 68, 0.1)"};
  border-radius: 20px;
  display: inline-block;
  width: fit-content;
  border: 1px solid
    ${(props) =>
      props.currentProject.status === 1
        ? "rgba(16, 185, 129, 0.2)"
        : "rgba(239, 68, 68, 0.2)"};
  vertical-align: middle;

  @media (max-width: 768px) {
    margin: 8px 0 0 0;
    display: block;
  }
`;

const Email = styled.span`
  font-size: 16px;
  color: #6b7280;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;

  &::before {
    content: "📧";
    font-size: 14px;
  }
`;

const ContentCardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  margin-top: 2rem;

  /* Ensure all grid items have the same width */
  & > * {
    width: 100%;
    min-width: 0;
  }

  /* Make the third item (Active Journals) span full width */
  & > *:nth-child(3) {
    grid-column: 1 / -1;
  }

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;

    /* Make the third item (Active Journals) span full width */
    & > *:nth-child(3) {
      grid-column: 1 / -1;
    }
  }

  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr;
    gap: 2.5rem;

    /* Make the third item (Active Journals) span full width */
    & > *:nth-child(3) {
      grid-column: 1 / -1;
    }
  }

  @media (min-width: 1280px) {
    grid-template-columns: 1fr 1fr;
    gap: 3rem;

    /* Make the third item (Active Journals) span full width */
    & > *:nth-child(3) {
      grid-column: 1 / -1;
    }
  }

  @media (min-width: 1536px) {
    grid-template-columns: 1fr 1fr;
    gap: 3rem;

    /* Make the third item (Active Journals) span full width */
    & > *:nth-child(3) {
      grid-column: 1 / -1;
    }
  }
`;

const ResponsiveWrapper = styled.div`
  /* Ensure all direct children have consistent width */
  & > * {
    width: 100%;
    min-width: 0;
  }

  /* Accessibility improvements */
  *:focus {
    outline: 2px solid rgba(227, 110, 0, 0.5);
    outline-offset: 2px;
  }

  /* Smooth scrolling for better UX */
  scroll-behavior: smooth;

  /* Global responsive overrides for all tables */
  .ant-table-wrapper,
  .MuiTableContainer-root {
    width: 100% !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
    border-radius: 0.75rem;
  }

  .ant-table,
  .MuiTable-root {
    width: 100% !important;
    min-width: auto !important;
  }

  .ant-table-container,
  .MuiTableContainer-root {
    width: 100% !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }

  .ant-table-content,
  .MuiTableBody-root {
    width: 100% !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }

  .ant-table-body {
    width: 100% !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }

  /* Force table scrolling on smaller screens */
  @media (max-width: 768px) {
    .ant-table-wrapper,
    .MuiTableContainer-root {
      overflow-x: scroll !important;
      scrollbar-width: thin !important;
    }

    .ant-table-body {
      overflow-x: scroll !important;
      scrollbar-width: thin !important;
    }
  }

  /* Responsive table cells for all table types */
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td,
  .MuiTableCell-root {
    @media (max-width: 768px) {
      padding: 0.5rem 0.25rem !important;
      font-size: 0.75rem !important;
      white-space: nowrap !important;
    }

    @media (max-width: 480px) {
      padding: 0.375rem 0.125rem !important;
      font-size: 0.6875rem !important;
    }
  }

  /* Responsive table headers */
  .ant-table-thead > tr > th,
  .MuiTableHead-root .MuiTableCell-root {
    @media (max-width: 768px) {
      font-size: 0.6875rem !important;
      padding: 0.5rem 0.25rem !important;
    }

    @media (max-width: 480px) {
      font-size: 0.625rem !important;
      padding: 0.375rem 0.125rem !important;
    }
  }

  /* Force responsive behavior for all table elements */
  .ant-table-tbody > tr > td,
  .ant-table-thead > tr > th,
  .MuiTableCell-root {
    width: auto !important;
    min-width: auto !important;
  }

  /* Ensure buttons are responsive */
  button {
    @media (max-width: 768px) {
      font-size: 0.6875rem !important;
      padding: 0.25rem 0.5rem !important;
      min-width: 3.75rem !important;
      height: 1.75rem !important;
    }

    @media (max-width: 480px) {
      font-size: 0.625rem !important;
      padding: 0.1875rem 0.375rem !important;
      min-width: 3.125rem !important;
      height: 1.5rem !important;
    }
  }

  /* Responsive tabs */
  .MuiTabs-root {
    @media (max-width: 768px) {
      font-size: 0.75rem !important;
    }

    @media (max-width: 480px) {
      font-size: 0.6875rem !important;
    }
  }

  /* Responsive accordion */
  .MuiAccordion-root {
    @media (max-width: 768px) {
      font-size: 0.75rem !important;
    }

    @media (max-width: 480px) {
      font-size: 0.6875rem !important;
    }
  }

  /* Responsive breadcrumbs */
  .MuiBreadcrumbs-root {
    @media (max-width: 768px) {
      font-size: 0.75rem !important;
    }

    @media (max-width: 480px) {
      font-size: 0.6875rem !important;
    }
  }

  /* Loading states */
  .loading {
    opacity: 0.7;
    pointer-events: none;
  }

  /* Better touch targets on mobile */
  @media (max-width: 768px) {
    button,
    a,
    [role="button"] {
      min-height: 2.5rem !important;
      min-width: 2.5rem !important;
    }
  }
`;

const SC = {
  Container,
  BodyHeader,
  BodyContainer,
  HeadingTag,
  FilterContainer,
  FilterOption,
  CardsContainer,
  DetailsCard,
  DetailsContent,
  DetailsSection,
  ImageSection,
  ImageCard,
  ImageContainer,
  Image,
  ProjectDiv,
  PropertyName,
  Status,
  Email,
  ContentCardsGrid,
  ResponsiveWrapper,
};

export default SC;
